import React from 'react';

const CalendarLegendKeyTypes = [
  'availability',
  'scheduled',
  'new-interview',
] as const;

export type CalendarLegendKeyType = (typeof CalendarLegendKeyTypes)[number];

export type CalendarLegendKeyProps = {
  type?: CalendarLegendKeyType;
  name?: string;
};

export const CalendarLegendKey = ({
  type = 'availability',
  name,
}: CalendarLegendKeyProps) => {
  return <div className={`calendarLegendKey ${type}Color`} data-test={name} />;
};
